import React, { useState } from "react";
import { format } from "date-fns";
import DateFilterModal from "./Sales Crm Modal/DateFilterModal";

const DateFilterComponent = ({ setDateForApi }) => {
  const [dateFilterModalOpen, setDateFilterModalOpen] = useState(false);
  const [date, setDate] = useState(null); // Initially null (no date selected)

  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange = (ranges) => {
    setDate(ranges); // Save selected date range
    setDateForApi(ranges); // Send to parent or API
  };

  return (
    <>
      <div className="col-md-3 mt-3">
  <label>Date</label>
  <div>
    <button
  onClick={() => setDateFilterModalOpen(true)}
  className="btn btn-outline-success w-100"
  style={{ height: "10px" }}
>
      {date
                ? `${format(date.startDate, "MMM dd yyyy")} -- ${format(
                    date.endDate,
                    "MMM dd yyyy"
                  )}`
                : "Select Calender Date"}
    </button>
  </div>
</div>

      <DateFilterModal
        dateFilterModalOpen={dateFilterModalOpen}
        handleCloseDateFilterModal={handleCloseDateFilterModal}
        date={date}
        onDateChange={handleDateChange}
      />
    </>
  );
};

export default DateFilterComponent;
